import React from 'react'
import Header from './components/mobile/MobileHeader'
import Hero from './components/mobile/Hero'
import MigrationSteps from './components/mobile/MigrationSteps'
import FAQ from './components/mobile/FAQ'
import VPNPromotion from './components/mobile/VPNPromotion'
import Footer from './components/shared/Footer'

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        <Hero />
        <MigrationSteps />
        <FAQ />
        <VPNPromotion />
      </main>
      <Footer />
    </div>
  )
}

export default App
